

























import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import RemplacementAlerts from "../RemplacementAlerts.vue";
import { Intervention } from "../../models/Intervention";
import { TableColumn } from "../../models/UI/TableColumn";
import { Option } from "../../models/Option";
import { ContactApi } from "../../api/ContactApi";
import { EmployeApi } from "../../api/EmployeApi";

export default {
    name: "RecurringInterventionsListFilters",
    components: {
        TableSort,
        TableFilters,
        RemplacementAlerts,
    },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            ContactApi: new ContactApi(),
            EmployeApi: new EmployeApi(),
            columns: [
                {
                    id: "planning_id",
                    name: "Planning",
                    type: TableColumn.ColumnType.text,
                    sort_field: "planning_id",
                },
                {
                    id: "clientIds",
                    name: "Client",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "clients.nom",
                },
                {
                    id: "titre",
                    name: "Intervention",
                    type: TableColumn.ColumnType.text,
                    sort_field: "titre",
                },
                {
                    id: "employeIds",
                    name: "Employé",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "employes.nom",
                },
                {
                    id: "frequenceIds",
                    name: "Fréquence",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                },
                {
                    id: "horaire_debut",
                    name: "Horaires",
                    type: TableColumn.ColumnType.text,
                    sort_field: "horaire_debut",
                },
                {
                    id: "duree_prevue",
                    name: "Durée",
                    sort_field: "duree_prevue",
                },
                {
                    id: "archived",
                    name: "Archivé",
                    type: TableColumn.ColumnType.boolean,
                    default_filter: true,
                    default_value: false,
                },
            ],
        };
    },
    created() {
        this.loadFilterOptions();
    },
    beforeMount() {
        this.applyDefaultFilters();
    },
    methods: {
        loadFilterOptions() {
            this.loadClientOptions();
            this.loadEmployeOptions();
            this.loadFrequenceOptions();
        },
        loadClientOptions() {
            this.ContactApi.getAllAsOptions({ useCache: true }).then((res) => {
                let col = _.find(this.columns, { id: "clientIds" });
                col.options = Option.toTags(
                    _.filter(res, function (c) {
                        return !!c.name;
                    })
                );
                // Add special options
                col.options.push({
                    ids: [-1],
                    text: "Vide",
                    classes: "empty-tag",
                });
            });
        },
        loadEmployeOptions() {
            this.EmployeApi.getAllAsOptions().then((res) => {
                let col = _.find(this.columns, { id: "employeIds" });
                col.options = Option.toTags(res);
                // Add special options
                col.options.push({
                    ids: [-1],
                    text: "Vide",
                    classes: "empty-tag",
                });
                col.options.push({
                    ids: [-2],
                    text: "Employés test",
                    classes: "empty-tag",
                });
            });
        },
        loadFrequenceOptions() {
            let col = _.find(this.columns, { id: "frequenceIds" });
            col.options = Option.toTags(Intervention.Frequence);
        },
        applyDefaultFilters() {
            if (!this.defaultFilters) return;

            // Apply default client filter if provided
            if (
                this.defaultFilters.has("client_id") &&
                this.defaultFilters.has("client_nom")
            ) {
                let col = _.find(this.columns, { id: "clientIds" });
                col.default_filter = true;
                col.default_value = [
                    {
                        ids: [this.defaultFilters.get("client_id")],
                        text: this.defaultFilters.get("client_nom"),
                        classes: "",
                    },
                ];
            }

            // Apply default employee filter if provided
            if (
                this.defaultFilters.has("employe_id") &&
                this.defaultFilters.has("employe_nom")
            ) {
                let col = _.find(this.columns, { id: "employeIds" });
                col.default_filter = true;
                col.default_value = [
                    {
                        ids: [this.defaultFilters.get("employe_id")],
                        text: this.defaultFilters.get("employe_nom"),
                        classes: "",
                    },
                ];
            }

            // Apply default frequency filter if provided
            if (this.defaultFilters.has("frequences")) {
                let col = _.find(this.columns, { id: "frequenceIds" });
                let freqIds = this.defaultFilters.getAll("frequences");
                col.default_filter = true;
                col.default_value = _.map(freqIds, function (f) {
                    return {
                        ids: [f],
                        text: Intervention.Frequence[f].shortname,
                    };
                });
            }

            // Apply default sort if provided
            if (this.defaultFilters.has("default_sort_id")) {
                let defaultCol = _.find(this.columns, { default_sort: true });
                if (defaultCol) {
                    defaultCol.default_sort = false;
                }
                let newCol = _.find(this.columns, {
                    id: this.defaultFilters.get("default_sort_id"),
                });
                if (newCol) {
                    newCol.default_sort = true;
                    newCol.default_value =
                        this.defaultFilters.get("default_sort_order") ||
                        TableColumn.SortOrder.asc;
                }
            }
        },
        updateFilters(newFilters) {
            this.filters = newFilters;
            this.$emit("update-filters", this.filters);
        },
        updateSort(sortData) {
            this.$emit("update-sort", sortData);
        },
        addIntervention() {
            this.$emit("action", "add-intervention");
        },
    },
};
